
export function useDescription() {
  const description = [
    'Showing the historical and short-term forecast development of crop commodities’ prices, as predicted by several different sources',
    'Source: USDA, ICE, NYSE (Historical Prices), CBOT, NYSE (Forecast Prices)',
  ];
  return description;
}